import {
  FETCH_CONTENT,
  FETCH_CONTENT_SUCCESS,
  FETCH_CONTENT_FAILURE,
  FILTER_CONTENT,
  HIDE_CONTENT,
  UNHIDE_CONTENT,
  HIDE_CONTENT_SUCCESS,
  UNHIDE_CONTENT_SUCCESS,
} from './constants';

export function fetchContent() {
  return {
    type: FETCH_CONTENT,
  };
}

export function fetchContentSuccess(data) {
  return {
    type: FETCH_CONTENT_SUCCESS,
    payload: data,
  };
}

export function fetchContentFailure() {
  return {
    type: FETCH_CONTENT_FAILURE,
    payload: null,
  };
}

export function filterContent(uid) {
  return {
    type: FILTER_CONTENT,
    payload: { uid },
  };
}

export function hideContent(uid) {
  return {
    type: HIDE_CONTENT,
    payload: { uid },
  };
}

export function hideContentSuccess(uid) {
  return {
    type: HIDE_CONTENT_SUCCESS,
    payload: { uid },
  };
}

export function unhideContent(uid) {
  return {
    type: UNHIDE_CONTENT,
    payload: { uid },
  };
}

export function unhideContentSuccess(uid) {
  return {
    type: UNHIDE_CONTENT_SUCCESS,
    payload: { uid },
  };
}
